export const blockIconsFileWorkspaces = (
	<span className='material-symbols-outlined'>workspaces</span>
);
